// import { Alert as AlertMantine } from '@mantine/core'
import React, { useState } from 'react'
import { useQuery } from 'react-query'

// import { ReactComponent as InfoIcon } from '../../../../icones/infoAmarelo.svg'
import { PortadorasService } from '../../../../services/http/portadoras.service'
// import { formatDateToLabel } from '../../../../utils/genericFormatters'
import Botao from '../../../Mantine/Botao'
import Group from '../../../Mantine/Group'
import LineSkeleton from '../../../Mantine/Skeleton/line'

import Grafico from './Grafico'
import * as S from './styles'

const buttons = [
  { value: '24h', label: 'Últimas 24h' },
  { value: '2d', label: 'Últimos 2 dias' },
  { value: '3d', label: 'Últimos 3 dias' },
  { value: '4d', label: 'Últimos 4 dias' },
  { value: '5d', label: 'Últimos 5 dias' },
  { value: '6d', label: 'Últimos 6 dias' },
  { value: '7d', label: 'Últimos 7 dias' }
]

export default function Consumo({ cdPortadora }) {
  // const [mostrarAlerta, setMostrarAlerta] = useState(false)
  // const [datasDisponiveis, setDatasDisponiveis] = useState({
  //   min: undefined,
  //   max: undefined
  // })
  const [selectedButton, setSelectedButton] = useState('24h')
  const [loading, setLoading] = useState()

  const { getConsumo } = PortadorasService

  const handleButtonFilter = (value) => {
    setSelectedButton(value)
    // setMostrarAlerta(false)
  }

  const { data } = useQuery(
    [`consumo-${cdPortadora}`, selectedButton],
    async () => {
      try {
        setLoading(true)
        return await getConsumo(cdPortadora, selectedButton)
      } catch (err) {
        console.error('Erro ao buscar consumo:', err)
        return [] // Evita erros ao mapear `data` caso falhe
      } finally {
        setLoading(false)
      }
    },
    {
      // onSuccess: (data) => {
      //   if (!data?.length) return

      //   const parsedDates = data.map((item) => parseISO(item.data))

      //   const today = new Date()
      //   const minDate = min(parsedDates)
      //   const maxDate = max(parsedDates)
      //   setDatasDisponiveis({
      //     min: minDate,
      //     max: maxDate
      //   })

      //   // Verifica se a data máxima é menor que hoje
      //   const isMaxDateBeforeToday = isBefore(maxDate, today)

      //   // Calcula a data inicial com base no periodo
      //   const days = parseInt(selectedButton, 10)
      //   const startDate = subDays(today, days)

      //   // Verifica se a menor data é maior que a data inicial
      //   const isMinDateAfterStartDate = isAfter(minDate, startDate)

      //   if (isMinDateAfterStartDate || isMaxDateBeforeToday) {
      //     setMostrarAlerta(true)
      //   }
      // },
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  // const handleFecharAlerta = () => setMostrarAlerta(false)

  // const getMensagemAlerta = () => {
  //   if (!datasDisponiveis?.min) return ''

  //   const dataInicio = formatDateToLabel(datasDisponiveis.min)
  //   const dataFim = formatDateToLabel(datasDisponiveis.max)

  //   const intervalo = isSameDay(datasDisponiveis.min, datasDisponiveis.max)
  //     ? `do dia ${dataInicio}`
  //     : `de ${dataInicio} a ${dataFim}`

  //   return `Nem todos os dias do período selecionado possuem dados disponíveis. Estamos exibindo as informações ${intervalo}.`
  // }

  return (
    <S.HistoricoWrapper>
      <Group>
        {buttons.map((button) => (
          <Botao
            disabled={loading}
            key={button.value}
            label={button.label}
            onClick={() => handleButtonFilter(button.value)}
            variant={button.value === selectedButton ? 'selected' : 'select'}
          />
        ))}
      </Group>
      {loading && <LineSkeleton height={305} visible={loading} />}
      {!loading && <Grafico data={data} />}
      {/* {mostrarAlerta && (
        <S.AlertWrapper>
          <AlertMantine
            radius="sm"
            title="Atenção!"
            type="warning"
            color="yellow"
            withCloseButton
            onClose={handleFecharAlerta}
            icon={<InfoIcon alt="info" />}
          >
            {getMensagemAlerta()}
          </AlertMantine>
        </S.AlertWrapper>
      )} */}
    </S.HistoricoWrapper>
  )
}
